/* eslint-disable react-native/no-inline-styles */
import React, { memo } from 'react';
import { Box, Stack, HStack } from 'native-base';
import { Typography } from 'fmc-digital-common';
const NTBBanner = /*#__PURE__*/memo(({
  children
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    width: {
      lg: 530,
      md: 530,
      base: 72
    },
    style: {
      shadowColor: '#111c2b1a',
      shadowOffset: {
        width: 0,
        height: 2
      },
      shadowRadius: 10
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    flexDirection: {
      base: 'column',
      lg: 'row',
      md: 'row'
    },
    space: {
      lg: 2,
      md: 2,
      sm: 0
    }
  }, /*#__PURE__*/React.createElement(Box, {
    width: {
      base: '100%',
      lg: 179,
      md: 179
    },
    height: {
      base: 13.75,
      lg: 110,
      md: 110
    },
    paddingX: 4,
    paddingY: {
      base: 3.25,
      lg: 2,
      md: 2
    },
    justifyContent: "center",
    alignItems: "center",
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: {
      base: 0,
      lg: 4,
      md: 4
    },
    borderTopRightRadius: {
      base: 4,
      lg: 0,
      md: 0
    },
    bgColor: 'primary.700'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2V2",
    textAlign: "center",
    color: "white.500"
  }, "Your Loan Benefits")), /*#__PURE__*/React.createElement(HStack, {
    paddingX: {
      base: 50,
      lg: 10,
      md: 10
    },
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: 'white.500'
  }, children)));
});
export default NTBBanner;
//# sourceMappingURL=NTBBanner.js.map